import ConsultaBase from "../shared/ConsultaBase";
import { fullServiceCoolingUnicoConsultaConfig } from "../config/fullServiceCoolingUnicoConsulta";

const CFSCUNICO = () => {
  return <ConsultaBase config={fullServiceCoolingUnicoConsultaConfig} />;
};

export default CFSCUNICO;